import React, { useEffect, useState, useContext, useRef } from 'react';
import Button from '@material-ui/core/Button';
import SelectCargo from '../../../../../components/Select/SelectCargo';
import SelectPackage from '../../../../../components/Select/SelectPackage';
import SelectLoad from '../../../../../components/Select/SelectLoad';
import TextField from '@material-ui/core/TextField';
import { toEN, formatNumber, rond } from '../../../../../fns';
import SelectAddress from '../../../../../components/Dialog/SelectAddress/SelectAddress';
import moment from 'moment-jalaali';
import { __ } from '../../../../../utils/i18n';
import DatePicker from '../../../../../components/Dialog/LoadingDatePicker';
import FormLabel from '@material-ui/core/FormLabel';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import FleetsTextField from '../../../../../components/TextFields/FleetsTextFields';
import axios from '../../../../../api/axios';
import { store as mainStore } from '../../../../../store';
import { store } from './AddOrder';
import WeightDialog from '../../../../../components/Dialog/WeightDialog/WeightDialog';
import { useLocation, useHistory } from 'react-router-dom';
import PriceWithLabel from '../../../../../components/TextFields/PriceWithLabel';
import {
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from '@material-ui/core';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  toggleContainer: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    '& > *': {
      marginLeft: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  button: {
    padding: theme.spacing(1, 6),
  },
  price: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridGap: theme.spacing(1),
    '& > *': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  insurance: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const AddForm = () => {
  const classes = useStyles();
  const history = useHistory();
  const { showMessage, showError } = useContext(mainStore);
  const { state, dispatch, actions } = useContext(store);
  const { values, error } = state;
  const { value, basePrice, proposedPrice } = values;
  const { customer } = values;
  const [addressDialog, setAddressDialog] = useState({
    open: false,
    type: null,
  });
  const [openDateDialog, setOpenDateDialog] = useState(false);
  const [weightDialog, setWeightDialog] = useState(false);
  const [isLoadingOrder, setIsLoadingOrder] = useState(false);
  const location = useLocation();
  let timeout = useRef();
  const [insurance, setInsurance] = useState(0);

  const validation = (e) => {
    const isSingleValidation = e || false;
    let er = {};

    // Validation patterns start here:
    if (!values.type) {
      er.type = 'نوع محموله را مشخص کنید.';
    }
    if (!values.packaging) {
      er.packaging = 'نوع بسته‌بندی را مشخص کنید.';
    }
    if (!values.weight || !values.weightType) {
      er.weight = 'وزن محموله را مشخص کنید.';
    }
    if (!values.value) {
      er.value = 'ارزش محموله را به میلیون تومان وارد کنید.';
    }
    if (!values.load) {
      er.load = 'حالت بارگیری را مشخص کنید.';
    }
    if (!values.origin) {
      er.origin = 'محل بارگیری را مشخص کنید.';
    }
    if (!values.destination) {
      er.destination = 'محل تخلیه را مشخص کنید.';
    }
    if (!values.loadDate || !values.loadTime) {
      er.loadDate = 'تاریخ بارگیری را مشخص کنید.';
    }
    if (
      !values.fleetOptions ||
      (values.fleetOptions && !values.fleetOptions.length)
    ) {
      er.fleetOptions = 'حداقل یک ناوگان انتخاب نمائید.';
    }
    if (!values.fleetCount || values.fleetCount < 1) {
      er.fleetCount = 'حداقل بایستی یک ناوگان درخواست شود.';
    }
    // Validation patterns end here.
    if (isSingleValidation) {
      let err = {};

      for (const v in state.values) {
        if (state.values[v]) {
          if (er[v]) {
            err[v] = er[v];
          }
        }
      }
      if (Object.entries(err).length) {
        dispatch({ type: 'ERROR', payload: err });
        return false;
      }
      {
        dispatch({ type: 'ERROR', payload: {} });
        return true;
      }
    } else {
      if (Object.entries(er).length) {
        dispatch({ type: 'ERROR', payload: er });
        return false;
      }
      dispatch({ type: 'ERROR', payload: er });
      return true;
    }
  };
  const handleSelect = (name, value) => {
    dispatch({ type: 'CHANGE_VALUES', payload: { name, value } });
  };
  const handleChange = (e) => {
    let { name, value } = e.target;
    let numberFields = [
      'lengthh',
      'height',
      'width',
      'value',
      'quantity',
      'workers',
      'fleetCount',
    ];
    numberFields.includes(name) && (value = toEN(value));
    if (name === 'value' && value.length > 4) return;
    dispatch({ type: 'CHANGE_VALUES', payload: { name, value } });
  };
  const handleChangeProposedPrice = (e) => {
    let proposedPrice = toEN(e.target.value);
    let basePrice = rond(proposedPrice * 1 - (insurance || 0) * 1);
    dispatch({ type: 'PRICE', payload: { proposedPrice, basePrice } });
  };
  const handleChangeBasePrice = (e) => {
    let basePrice = toEN(e.target.value);
    let proposedPrice = rond((insurance || 0) * 1 + basePrice * 1);
    dispatch({ type: 'PRICE', payload: { proposedPrice, basePrice } });
  };
  const handleCloseSelectAddress = () => {
    setAddressDialog({ open: false, type: null });
  };
  const handleCloseAndSaveSelectAddress = ({ addressType, address = null }) => {
    if (addressType === 'origin') {
      dispatch({
        type: 'CHANGE_VALUES',
        payload: {
          name: 'origin',
          value: {
            ...state.origin,
            ...address,
          },
        },
      });
    } else {
      dispatch({
        type: 'CHANGE_VALUES',
        payload: {
          name: 'destination',
          value: {
            ...state.destination,
            ...address,
          },
        },
      });
    }
    // setValues({
    //   ...values,
    //   [addressType]: { ...values[addressType], ...address },
    // });
    setAddressDialog({ open: false, type: null });
  };
  const handleOpenSelectAddress = (addressType) => {
    setAddressDialog({ open: true, type: addressType });
  };
  const handleToggleDatePicker = () => {
    setOpenDateDialog(!openDateDialog);
  };
  const handleSaveOrder = async () => {
    if (!validation()) {
      showError('خطاهای مشخص شده را برطرف نمائید.');
      return;
    }
    const {
      type,
      quantity,
      packaging,
      value,
      load,
      workers,
      loadTime,
      loadDate,
      origin,
      destination,
      unloadTime,
      fleetOptions,
      fleetCount,
      description,
      description2,
      weight,
      weightType,
      customer,
      payType,
      waybillType,
      proposedPrice,
      basePrice,
      weighbridge,
    } = values;
    let data = {
      fleetCount: fleetCount,
      fleetOptions: fleetOptions.map((fl) => fl._id),
      originState: origin.city.state._id,
      destinationState: destination.city.state._id,
      origin: origin.city._id,
      destination: destination.city._id,
      unloadTime,
      loadDate,
      loadTime,
      customer,
      payType,
      waybillType,
      proposedPrice,
      basePrice,
      insurance,
      weighbridge,
      cargos: [
        {
          workers,
          loadDate,
          unloadTime,
          quantity: weight,
          description,
          description2,
          value,
          loadTime,
          packaging: packaging?._id,
          type: type._id,
          load: load._id,
          origin,
          destination,
          unit: weightType,
        },
      ],
    };
    try {
      setIsLoadingOrder(true);
      const {
        data: { messages, order },
      } = await axios.post(`/api/v1/admin/orders/add`, data);
      showMessage(messages);
      history.push(`/protected/admin/orders/${order._id}`);
    } catch (error) {
      showError(error);
    } finally {
      setIsLoadingOrder(false);
    }
  };
  const handleChangeFleetsTF = (selection) => {
    dispatch({
      type: 'CHANGE_VALUES',
      payload: { name: 'fleetOptions', value: selection },
    });
  };
  const handleOpenWeightD = () => {
    setWeightDialog(true);
  };
  const handleCloseWD = (obj) => {
    const { weight, weightType } = obj;
    setWeightDialog(false);
    dispatch({
      type: 'CHANGE_VALUES',
      payload: { name: 'weight', value: weight },
    });
    dispatch({
      type: 'CHANGE_VALUES',
      payload: { name: 'weightType', value: weightType },
    });
  };
  const handleChangeCB = (e) => {
    const { name, checked } = e.target;
    dispatch({
      type: 'CHANGE_VALUES',
      payload: { name, value: checked },
    });
  };
  const calcInsurance = async (cargoValue) => {
    try {
      const insurance = await actions.calcInsurance(cargoValue);
      insurance && setInsurance(insurance);
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    if (!value) return;
    timeout.current && clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      calcInsurance(value);
    }, 1000);
  }, [value]);
  useEffect(() => {
    if (values?.proposedPrice && values?.basePrice) return;
    if (!insurance) return;
    var proposedPrice, basePrice;
    if (!values?.proposedPrice) {
      proposedPrice = rond(values?.basePrice * 1 + insurance * 1);
      basePrice = values?.basePrice;
    } else {
      basePrice = rond(values?.proposedPrice * 1 - insurance * 1);
      proposedPrice = values?.proposedPrice;
    }
    dispatch({ type: 'PRICE', payload: { proposedPrice, basePrice } });
  }, [insurance]);

  return (
    <>
      {weightDialog ? (
        <WeightDialog
          onClose={handleCloseWD}
          w={values.weight}
          wt={values.weightType}
        />
      ) : null}
      <div className={classes.root}>
        <SelectCargo
          cargo={values.type ? values.type : null}
          onSelect={(cargo) => handleSelect('type', cargo)}
          error={error.type ? error.type : false}
        />

        {values.type && values.type.worker && (
          <TextField
            fullWidth
            label="تعداد کارگر"
            variant="outlined"
            size="small"
            name="workers"
            value={values.workers ? values.workers : ''}
            onChange={handleChange}
          />
        )}

        <TextField
          fullWidth
          label="وزن محموله"
          variant="outlined"
          value={
            !!values.weight ? values.weight + ' ' + __(values.weightType) : ''
          }
          size="small"
          onChange={null}
          onClick={handleOpenWeightD}
          error={error.weight ? true : false}
          helperText={error.weight ? error.weight : ''}
        />

        <SelectPackage
          pack={values.packaging ? values?.packaging : null}
          onSelect={(pack) => handleSelect('packaging', pack)}
          error={error.packaging ? error.packaging : false}
        />

        <TextField
          fullWidth
          label="ارزش محموله (میلیون تومان)"
          variant="outlined"
          value={values.value ? values.value : ''}
          size="small"
          name="value"
          onChange={handleChange}
          type="number"
          error={error.value ? true : false}
          helperText={error.value ? error.value : ''}
        />

        <SelectLoad
          load={values.load ? values.load : null}
          onSelect={(load) => handleSelect('load', load)}
          error={error.load ? error.load : false}
        />

        {values.load && values.load.isCube && (
          <>
            <TextField
              fullWidth
              label="طول"
              name="lengthh"
              variant="outlined"
              size="small"
              value={values.lengthh ? values.lengthh : ''}
              onChange={handleChange}
            />

            <TextField
              fullWidth
              label="عرض"
              name="width"
              variant="outlined"
              size="small"
              value={values.width ? values.width : ''}
              onChange={handleChange}
            />

            <TextField
              fullWidth
              label="ارتفاع"
              name="height"
              variant="outlined"
              size="small"
              value={values.height ? values.height : ''}
              onChange={handleChange}
            />
          </>
        )}

        <TextField
          fullWidth
          label="محل بارگیری"
          size="small"
          name="origin"
          variant="outlined"
          onClick={() => handleOpenSelectAddress('origin')}
          value={`${
            values?.origin?.city?.state?.title
              ? `${values.origin.city.state.title}`
              : ''
          } ${
            values?.origin?.city?.title ? `، ${values.origin.city.title}` : ''
          } ${
            values?.origin?.details ? ` - آدرس: ${values.origin.details}` : ''
          } ${
            values?.origin?.transferee ? ` - ${values.origin.transferee}` : ''
          } ${
            values?.origin?.mobilePhone ? ` - ${values.origin.mobilePhone}` : ``
          } ${
            values?.origin?.zipcode ? ` - کدپستی: ${values.origin.zipcode}` : ``
          } ${
            values?.origin?.nationalCode
              ? ` - کدملی:${values?.origin?.nationalCode}`
              : ``
          } ${
            values?.origin?.companyNationalCode
              ? ` - شناسه ملی شرکت:${values?.origin?.companyNationalCode}`
              : ``
          }`}
          error={error.origin ? true : false}
          multiline
          helperText={error.origin ? error.origin : ''}
        />

        <TextField
          fullWidth
          size="small"
          label="تاریخ بارگیری"
          name="loadDate"
          variant="outlined"
          onClick={handleToggleDatePicker}
          value={
            values.loadDate && values.loadTime
              ? `${moment(values.loadDate).format(
                  'jYYYY/jMM/jDD'
                )} ساعت بارگیری ${__(values.loadTime)}`
              : ''
          }
          error={error.loadDate ? true : false}
          helperText={error.loadDate ? error.loadDate : ''}
        />

        <TextField
          fullWidth
          label="محل تخلیه"
          size="small"
          name="destination"
          variant="outlined"
          onClick={() => handleOpenSelectAddress('destination')}
          value={`${
            values?.destination?.city?.state?.title
              ? `${values.destination.city.state.title}`
              : ''
          } ${
            values?.destination?.city?.title
              ? `، ${values.destination.city.title}`
              : ''
          } ${
            values?.destination?.details
              ? ` - آدرس: ${values.destination.details}`
              : ''
          } ${
            values?.destination?.transferee
              ? ` - ${values.destination.transferee}`
              : ''
          } ${
            values?.destination?.mobilePhone
              ? ` - ${values.destination.mobilePhone}`
              : ``
          } ${
            values?.destination?.zipcode
              ? ` - کدپستی: ${values.destination.zipcode}`
              : ``
          } ${
            values?.destination?.nationalCode
              ? ` - کدملی:${values?.destination?.nationalCode}`
              : ``
          } ${
            values?.destination?.companyNationalCode
              ? ` - شناسه ملی شرکت:${values?.destination?.companyNationalCode}`
              : ``
          }`}
          error={error.destination ? true : false}
          multiline
          helperText={error.destination ? error.destination : ''}
        />

        <FleetsTextField
          weight={values.weight}
          weightType={values.weightType}
          onChange={handleChangeFleetsTF}
          selection={values.fleetOptions ? values.fleetOptions : []}
          error={error.fleetOptions ? error.fleetOptions : false}
        />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr 1fr' : '9fr 3fr',
            gridGap: 10,
          }}
        >
          <TextField
            fullWidth
            label="تعداد ناوگان"
            value={values.fleetCount ? values.fleetCount : 1}
            onChange={handleChange}
            name="fleetCount"
            variant="outlined"
            size="small"
            error={error.fleetCount ? true : false}
            helperText={error.fleetCount ? error.fleetCount : ''}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={values?.weighbridge ? true : false}
                onChange={handleChangeCB}
                name="weighbridge"
              />
            }
            label="باسکول دارد؟"
          />
        </div>

        <TextField
          multiline
          minRows={4}
          fullWidth
          variant="outlined"
          name="description"
          value={values.description ? values.description : ''}
          onChange={handleChange}
          label="توضیحات بار"
        />
        <TextField
          multiline
          minRows={4}
          fullWidth
          variant="filled"
          name="description2"
          value={values.description2 ? values.description2 : ''}
          onChange={handleChange}
          label="توضیحات اپراتور"
        />

        <div>
          <div className={classes.toggleContainer}>
            <FormLabel>زمان تخلیه</FormLabel>
            <ToggleButtonGroup
              value={values.unloadTime}
              exclusive
              name="unloadTime"
              onChange={(e, value) =>
                dispatch({
                  type: 'CHANGE_VALUES',
                  payload: { name: 'unloadTime', value },
                })
              }
              size="small"
            >
              <ToggleButton
                key={1}
                value="day"
                className={classes.toggleButton}
              >
                روز
              </ToggleButton>
              <ToggleButton
                key={2}
                value="nodiffer"
                className={classes.toggleButton}
              >
                فرقی نمی کند
              </ToggleButton>
              <ToggleButton
                key={3}
                value="night"
                className={classes.toggleButton}
              >
                شب
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <div className={classes.toggleContainer}>
            <FormLabel>نوع بارنامه</FormLabel>
            <ToggleButtonGroup
              value={values.waybillType}
              exclusive
              name="waybillType"
              onChange={(e, value) =>
                dispatch({
                  type: 'CHANGE_VALUES',
                  payload: { name: 'waybillType', value },
                })
              }
              size="small"
            >
              <ToggleButton
                key={'w1'}
                value="software"
                className={classes.toggleButton}
              >
                کامل
              </ToggleButton>
              <ToggleButton
                key={'w2'}
                value="police"
                className={classes.toggleButton}
              >
                پلیس‌راهی
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <div className={classes.toggleContainer}>
            <FormLabel>پرداخت در مقصد</FormLabel>
            <ToggleButtonGroup
              value={values.payType}
              exclusive
              name="payType"
              onChange={(e, value) =>
                dispatch({
                  type: 'CHANGE_VALUES',
                  payload: { name: 'payType', value },
                })
              }
              size="small"
            >
              <ToggleButton
                key={'p1'}
                value="atDestination"
                className={classes.toggleButton}
              >
                در مقصد
              </ToggleButton>
              <ToggleButton
                key={'p2'}
                value="withWallet"
                className={classes.toggleButton}
              >
                کیف پول
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>
        <div className={classes.price}>
          <PriceWithLabel
            rows={4}
            fullWidth
            variant="outlined"
            name="basePrice"
            value={basePrice ? basePrice : ''}
            onChange={handleChangeBasePrice}
            label="کرایه حمل"
            position="down"
          />
          <div className={classes.insurance}>
            <div style={{ fontSize: 20, fontWeight: 900, color: 'green' }}>
              +
            </div>
            <div>{`${formatNumber(insurance || 0)} تومان`}</div>
            <div style={{ fontSize: 20, fontWeight: 900, color: 'green' }}>
              =
            </div>
          </div>
          <div className={classes.total}>
            <PriceWithLabel
              rows={4}
              fullWidth
              variant="outlined"
              name="proposedPrice"
              value={proposedPrice ? proposedPrice : ''}
              onChange={handleChangeProposedPrice}
              label="کرایه کل"
              position="down"
            />
          </div>
        </div>
        <div></div>
        <div>صفر یا خالی بودن کرایه حمل به معنی توافقی است</div>
      </div>
      <Button
        onClick={handleSaveOrder}
        variant="contained"
        color="secondary"
        size="medium"
        className={classes.button}
        disabled={isLoadingOrder}
        endIcon={isLoadingOrder ? <CircularProgress size={'10px'} /> : <></>}
      >
        افزودن
      </Button>

      {addressDialog.open && (
        <SelectAddress
          addressType={addressDialog.type}
          address={values[addressDialog.type]}
          onClose={handleCloseSelectAddress}
          onSave={handleCloseAndSaveSelectAddress}
          _customer={customer}
        />
      )}
      {openDateDialog && (
        <DatePicker
          open={true}
          onClose={({ date, time }) => {
            dispatch({
              type: 'CHANGE_VALUES',
              payload: { name: 'loadDate', value: date },
            });
            dispatch({
              type: 'CHANGE_VALUES',
              payload: { name: 'loadTime', value: time },
            });
            handleToggleDatePicker();
          }}
        />
      )}
    </>
  );
};

export default React.memo(AddForm);
